export default __webpack_public_path__ + "static/Graphik-SemiboldItalic-Cy-Web-84683b6304208745bbb98f0abffb5546.woff2";